import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { ToastService } from 'src/app/services/toast/toast.service';

@Component({
  selector: 'app-create-scheme',
  templateUrl: './create-scheme.component.html',
  styleUrls: ['./create-scheme.component.scss']
})
export class CreateSchemeComponent implements OnInit {
  form
  submitted: boolean = false
  skuList: any = []
  bannerImg = null;
  thabnilImag = null;
  schemeId: any = ''
  schemeConfig: any = {}
  schemeDetail: any = {}
  thambnilImg: any = ''

  @Output() createScheme: EventEmitter<object> = new EventEmitter;



  @Input() id = "";
  constructor(
    private fb: FormBuilder,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private toast: ToastClientService
  ) {
    this.createForm()

  }

  createForm() {
    this.form = this.fb.group({
      'scheme_title': new FormControl('', [Validators.required]),
      'start_date': new FormControl('', [Validators.required]),
      'end_date': new FormControl('', [Validators.required]),
      'scheme_description': new FormControl('', [Validators.required]),
      'eligibility': new FormControl('', [Validators.required]),
      'reward_description': new FormControl('', [Validators.required]),
      'banner_image': new FormControl('', [Validators.required]),
      'reward_type': new FormControl("1", [Validators.required]),
      'bill_proof': new FormControl(null, [Validators.required]),
      'thumbnail_image': new FormControl(null, [Validators.required]),
      'buffer_date':new FormControl(''),
      'schemes': this.fb.array([])
    });
  }

  ngOnInit() {
    this.schemeConfig = JSON.parse(localStorage.getItem('scheme_config'))

    this.addScheme()
    this.getSkuList()
    if (this.id != '0') {
      this.getSchame()
    }
    else if (this.schemeConfig.scheme_id != '' && this.schemeConfig.scheme_id != null && this.schemeConfig.scheme_id != undefined) {
      this.id = this.schemeConfig.scheme_id
      this.getSchame()
    }
  }

  getSchame() {
    this.apiService.get(this.apiConfig.listScheme + `?scheme_id=${this.id}`).subscribe((res: any) => {
      console.log(res)
      this.schemeDetail = res.data
      this.createForm()
      this.form.get('scheme_title').setValue(res.data.scheme_name);
      this.form.get('start_date').setValue(res.data.start_date);
      this.form.get('end_date').setValue(res.data.end_date);
      this.form.get('scheme_description').setValue(res.data.scheme_description);
      this.form.get('eligibility').setValue(res.data.scheme_eligibility);
      this.form.get('reward_description').setValue(res.data.reward_description);
      this.form.get('bill_proof').setValue(res.data.bill_proof);
      this.form.get('buffer_date').setValue(res.data.buffer_date);

      // clear
      this.form.controls["banner_image"].clearValidators();
      this.form.controls["banner_image"].setErrors(null);
      this.form.controls["banner_image"].updateValueAndValidity();
      // clear
      this.form.controls["thumbnail_image"].clearValidators();
      this.form.controls["thumbnail_image"].setErrors(null);
      this.form.controls["thumbnail_image"].updateValueAndValidity();

      // this.form.get('thumbnail_image').setValue(res.data.thumbnail_image);
      // this.form.get('banner_image').setValue(res.data.scheme_banner_image);
      res.data.sku_details.forEach((e: any) => {
        this.addScheme(e)
      });
    })
  }

  getSkuList() {
    this.apiService.get(this.apiConfig.getSchemeProductCategory).subscribe((res: any) => {
      console.log(res)
      this.skuList = res.data.ecommerce_categories;
    },(err:any)=>{
      this.toast.Error(err);
    })
  }

  get f() {
    return this.form.controls;
  }
  addScheme(user?: any) {
    let fg = this.fb.group({
      'id': [user ? user.sku_name : '', Validators.compose([Validators.required])],

    });
    (<FormArray>this.form.get('schemes')).push(fg);
  }

  deleteScheme(index: number) {
    (<FormArray>this.form.get('schemes')).removeAt(index);
  }

  onSubmit(value) {
    console.log(value)

    console.log(value.banner_image)
    this.submitted = true
    if (this.form.invalid) {
      return
    }
    const formdata = new FormData()
        if (this.id != '0') {
          formdata.append('id', this.id)
        }
    formdata.append('scheme_title', value.scheme_title)
    formdata.append('start_date', value.start_date)
    formdata.append('end_date', value.end_date)
    formdata.append('scheme_description', value.scheme_description)
    formdata.append('eligibility', value.eligibility)
    formdata.append('participating_SKU', JSON.stringify(value.schemes))
    formdata.append('reward_description', value.reward_description)
    formdata.append('bill_proof', value.bill_proof)
    formdata.append('buffer_date', value.buffer_date)
    formdata.append('banner_image', this.schemeDetail.scheme_banner_image == null ? this.bannerImg : this.schemeDetail.scheme_banner_image)
    formdata.append('thumbnail_image', this.schemeDetail.thumbnail_image == null ? this.thabnilImag : this.schemeDetail.thumbnail_image)

    debugger
    this.apiService.uploadFile(this.apiConfig.createScheme, formdata).subscribe((res: any) => {
      try {
        console.log(res.body.data)
        this.schemeId = res.body.data.scheme_id
        let parentObj = {
          schecme_created: true,
          scheme_id: this.schemeId
        }
        this.createScheme.emit(parentObj)
      } catch {

      }
    })
  }
  onBillProifSelected(event: any) {
    const file: File = event.target.files[0]; // Access the selected file
    this.bannerImg = file
    // this.form.get('bill_proof').setValue(file); 
  }

  onThambnilSelected(event: any) {
    const file: File = event.target.files[0]; // Access the selected file
    this.thabnilImag = file
    // this.form.get('thumbnail_image').setValue(file); 
  }


  removeThumbnail() {
    this.schemeDetail.thumbnail_image = null
    //set
    this.form.controls["thumbnail_image"].setValidators(Validators.required);
    this.form.controls["thumbnail_image"].updateValueAndValidity();
  }

  removeBanner() {
    this.schemeDetail.scheme_banner_image = null
    //set
    this.form.controls["banner_image"].setValidators(Validators.required);
    this.form.controls["banner_image"].updateValueAndValidity();

  }
}
